<template>
  <Slide right>
    <nav id="nav-side" class="flex-column">
      <ol class="nav flex-column navbar-menu" data-menu="0">
        <li class="nav-item active">
          <router-link :to="{name: 'mis-creditos'}" class="nav-link"> Mis créditos </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{name: 'mi-perfil'}" class="nav-link"> Mi perfil </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{name: 'tips'}" class="nav-link"> Pagos </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{name: 'ayuda'}" class="nav-link"> Ayuda </router-link>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Cerrar sesión</a>
        </li>
      </ol>
		</nav>
  </Slide>
</template>

<script>
import { Slide } from 'vue-burger-menu'

export default {

  components: {
    Slide
  }
  
}
</script>